import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import * as bp from 'breakpoints';
import { UserMenu } from 'templates';
import { LinkButton } from 'molecules';
import { useUser, useClerk } from '@clerk/clerk-react';

const UserFieldContainer = styled.div`
  display: grid;
  grid-auto-flow: column dense;
  align-items: center;
  padding: 1.134rem 1.67rem;
  height: 2.67rem;
  z-index: 2;
  user-select: none;

  @media (min-width: ${bp.PAD_S}) {
    position: absolute;
    top: 0;
    right: 0;
  }
`;

export const UserField = () => {
  const { t } = useTranslation();
  const { user } = useUser();
  const { signOut } = useClerk();

  return (
    <UserFieldContainer>
      {user ? (
        <UserMenu user={user} onLogout={signOut} />
      ) : (
        <LinkButton primary to="/auth/login">
          {t('login')}
        </LinkButton>
      )}
    </UserFieldContainer>
  );
};

export default UserField;
